import { Box, Text } from '@elkaso-app/web-design';
import React, { memo } from 'react';
import { GoogleMap, Marker, withGoogleMap, withScriptjs } from 'react-google-maps';

interface ReadOnlyMapProps {
  lat: number;
  lng: number;
  title?: string;
  height?: string;
  zoom?: number;
}

// Default center for Saudi Arabia
const DEFAULT_CENTER = {
  lat: 24.7136,
  lng: 46.6753,
};

// Custom marker icon
const MARKER_ICON = {
  path: 'M15.3579 35.6744C15.3579 19.8548 28.2724 10.25 40.6254 10.25C52.9783 10.25 65.8928 19.8548 65.8928 35.6744C65.8928 50.6465 43.4328 73.5285 42.5906 74.3759C42.0291 74.9409 41.4676 75.2234 40.6254 75.2234C39.7831 75.2234 39.2216 74.9409 38.6601 74.3759C37.8179 73.5285 15.3579 50.6465 15.3579 35.6744ZM40.9999 49.0536C48.2782 49.0536 54.1785 42.9894 54.1785 35.5089C54.1785 28.0284 48.2782 21.9643 40.9999 21.9643C33.7216 21.9643 27.8213 28.0284 27.8213 35.5089C27.8213 42.9894 33.7216 49.0536 40.9999 49.0536Z',
  fillColor: '#E53E3E',
  fillOpacity: 1,
  anchor: { x: 41, y: 78 },
  strokeWeight: 0,
  scale: 0.8,
};

const GoogleMapComponent = withScriptjs(
  withGoogleMap((props: any) => {
    const { lat, lng, title, zoom = 15 } = props;

    const center = {
      lat: lat || DEFAULT_CENTER.lat,
      lng: lng || DEFAULT_CENTER.lng,
    };

    return (
      <GoogleMap
        zoom={zoom}
        center={center}
        defaultOptions={{
          disableDefaultUI: true,
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels',
              stylers: [{ visibility: 'off' }],
            },
          ],
        }}>
        <Marker position={center} title={title} icon={MARKER_ICON as any} />
      </GoogleMap>
    );
  })
);

export const ReadOnlyMap: React.FC<ReadOnlyMapProps> = memo(({ lat, lng, title, height, zoom }) => {
  if (!lat || !lng) {
    return (
      <Box
        height={height || '300px'}
        borderRadius='md'
        bg='gray.100'
        display='flex'
        alignItems='center'
        justifyContent='center'
        border='1px'
        borderColor='gray.200'>
        <Text color='gray.500' fontSize='sm'>
          No coordinates available to display map
        </Text>
      </Box>
    );
  }

  return (
    <Box border='1px' borderColor='gray.200' borderRadius='md' overflow='hidden'>
      <GoogleMapComponent
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=AIzaSyD0eC_j5MVeV5YsOIRnLVRyIx9npurleUA&region=SA&libraries=places&language=en`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: height || '300px', borderRadius: '8px', overflow: 'hidden' }} />}
        mapElement={<div style={{ height: `100%` }} />}
        {...{ lat, lng, title, zoom }}
      />
    </Box>
  );
});

ReadOnlyMap.displayName = 'ReadOnlyMap';
